import axios, { AxiosInstance } from "axios";

const placesApiProvider: AxiosInstance = axios.create({
  baseURL: "https://places.googleapis.com/v1",
  headers: {
    "Content-Type": "application/json",
    "X-Goog-Api-Key": import.meta.env.VITE_GOOGLE_PLACES_API_KEY,
  },
});

export const getPhotoUrl = (name: string) => {
  return `${placesApiProvider.defaults.baseURL}/${name}/media?key=${placesApiProvider.defaults.headers["X-Goog-Api-Key"]}&maxHeightPx=640`;
};

export default placesApiProvider;
